import { DEFAULT_LOCALE } from '../constants/intl';
import { AllowedThemeName } from '../constants/theme';
import { STORAGE_KEYS } from '../services/configuration/common';
import store from '../store';
import connection from '../store/slices/connection';
import intl from '../store/slices/intl';
import theme from '../store/slices/theme';

import messages from './messages';

const initializeIntl = () => {
  for (const locale of Object.keys(messages) as Array<keyof typeof messages>) {
    store.dispatch(
      intl.loadMessages({
        locale,
        messages: messages[locale],
      })
    );
  }

  store.dispatch(intl.switchLocale(DEFAULT_LOCALE));
};

const initializeTheme = () => {
  const userTheme = localStorage.getItem('theme') as AllowedThemeName | null;
  store.dispatch(theme.apply(userTheme));
};

const connectToServer = () => {
  const storedCredentials = sessionStorage.getItem(
    STORAGE_KEYS.STORED_CREDENTIALS
  );
  const connectAction = storedCredentials
    ? connection.connectAndSignIn({ isReconnection: false })
    : connection.connect();

  store.dispatch(connectAction);
};

const startupConfiguration = {
  locked: false,
  run: () => {
    if (startupConfiguration.locked) {
      return;
    }

    initializeIntl();
    initializeTheme();
    connectToServer();
  },
};

if (module.hot) {
  module.hot.addStatusHandler(status => {
    if (status === 'prepare') {
      startupConfiguration.locked = true;
    }
  });
}

export default startupConfiguration.run;
